import React from "react";
import { Settings } from "lucide-react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

interface HeaderProps {
  onOpenSettings: () => void;
}

export const Header: React.FC<HeaderProps> = ({ onOpenSettings }) => {
  return (
    <header className="flex items-center justify-between px-4 py-4 md:py-6">
      <div className="flex items-center gap-3">
        <div className="text-4xl">🫧</div>
        <div>
          <h1 className="text-3xl md:text-4xl font-bold tracking-tight bg-gradient-to-r from-pink-500 via-cyan-500 to-yellow-400 bg-clip-text text-transparent">
            Bingo Blast!
          </h1>
          <p className="text-sm text-pink-600/70 -mt-1">
            The happiest way to play bingo
          </p>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <Link
          to="/"
          className="rounded-full bg-white/80 px-3 py-2 text-xs font-semibold text-zinc-800 shadow-lg backdrop-blur hover:bg-white"
        >
          Hall
        </Link>
        <motion.button
          whileHover={{ scale: 1.1, rotate: 15 }}
          whileTap={{ scale: 0.9 }}
          onClick={onOpenSettings}
          className="p-3 rounded-full bg-white/80 backdrop-blur shadow-lg hover:bg-white transition-colors bouncy-btn"
          aria-label="Open settings"
        >
          <Settings className="w-6 h-6 text-pink-600" />
        </motion.button>
      </div>
    </header>
  );
};
